import React from 'react'
import Select, { components } from 'react-select'
import makeAnimated from 'react-select/animated'
import MyDropdownIcon from '../../../../../img/caretDownGeneric.svg'
import { customStyles } from './CustomStyles'
import styles from './styles.module.css'
import { PrimaryCategories } from './PrimaryCategoriesValues'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

const PrimaryCategoriesOptions = PrimaryCategories.map(category => ({
  value: category,
  label: category
}))

// Custom Dropdown Indicator using <img> tag
const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        src={MyDropdownIcon}
        alt='Dropdown Icon'
        style={{ width: '8px', height: '13px' }}
      />
    </components.DropdownIndicator>
  )
}

function PrimaryCategoriesFilter ({
  localPrimaryCategories,
  setLocalPrimaryCategories
}) {
  const animatedComponents = makeAnimated()

  const customComponents = {
    ...animatedComponents,
    DropdownIndicator
  }

  // Convert the store's primaryCategories to the format expected by react-select
  const selectedOptions = PrimaryCategoriesOptions.filter(option =>
    localPrimaryCategories.includes(option.value)
  )

  // Handle changes in the Select component
  const handleChange = selected => {
    // selected can be null if all options are cleared
    const values = selected ? selected.map(option => option.value) : []
    setLocalPrimaryCategories(values)
  }

  return (
    <div className={styles.PrimaryCategoriesSection}>
      <div className={styles.inlineLabel}>
        <h1 className={styles.PrimaryCategoriesLabel}>Primary category</h1>
        <Tooltip
          title='Filter by the product’s primary category.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Primary category help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <Select
        closeMenuOnSelect={false}
        components={customComponents}
        isMulti
        options={PrimaryCategoriesOptions}
        styles={customStyles}
        value={selectedOptions}
        onChange={handleChange}
        placeholder='Select'
      />
    </div>
  )
}

export default PrimaryCategoriesFilter
